class Node {
    key;
    name;
    children;
    selectable;
    constructor(key, children = [], selectable = true, name) {
        this.key = key;
        if (name === undefined) {
            this.name = key;
        }
        else {
            this.name = name;
        }
        this.children = children;
        this.selectable = selectable;
    }
    /**
     * Returns this node's children and all nested subchildren in one long
     * flat array.
     * @returns {Node[]}
     */
    nestedChildren() {
        let items = [];
        for (const item of this.children) {
            items.push(item, ...item.nestedChildren());
        }
        return items;
    }
    *nestedChildrenGenerator() {
        for (const item of this.children) {
            yield item;
            yield* item.nestedChildren();
        }
    }
    addChild(key) {
        const child = new Node(key);
        this.children.push(child);
        return child;
    }
}
export default {
    Node
};
